import './valueProps.scss';

import React from 'react';
import DeliveryTruckIcon from 'images/icons/delivery-truck-outline.svg?react-svg';
import NoMinimumsIcon from 'images/icons/no-minimums.svg?react-svg';
import SelectionIcon from 'images/icons/selection-outline.svg?react-svg';

function ValueProps() {
  return (
    <div className="row around-sm">
      <div className="col-xs-12 col-sm-4 col-md-3">
        <div className="value-props__item">
          <div className="value-props__image row center-xs middle-xs">
            <SelectionIcon />
          </div>
          <h2 className="value-props__heading">The Best Selection</h2>
          <p className="value-props__description">
            Shop your favorite craft beer, wine, spirits, & mixers.
          </p>
        </div>
      </div>
      <div className="col-xs-12 col-sm-4 col-md-3">
        <div className="value-props__item">
          <div className="value-props__image row center-xs middle-xs">
            <DeliveryTruckIcon />
          </div>
          <h2 className="value-props__heading">Delivered Fast</h2>
          <p className="value-props__description">
            Right to your door! Track your order with a click.
          </p>
        </div>
      </div>
      <div className="col-xs-12 col-sm-4 col-md-3">
        <div className="value-props__item">
          <div className="value-props__image row center-xs middle-xs">
            <NoMinimumsIcon />
          </div>
          <h2 className="value-props__heading">No Minimums</h2>
          <p className="value-props__description">
            Order exactly what you want. Cheers, friends.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ValueProps;



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/valueProps.js